module.exports = __webpack_public_path__ + "static/img/penciledit.eb5cc640.svg";